export module EnumType {

    export enum Status {
        PENDING = 'Pending',
        ACTIVE = 'Active',
        DELETED = 'Deleted',
        INACTIVE = 'Inactive'
    }

    export enum Role {
        ACCOUNT_ADMIN = 'account_admin',
        SYS_ADMIN = 'sys_admin',
    }

    export enum Platform {
        WEB = 'Web',
        MOBILE = 'Mobile'
    }

    export enum LocalStorage {
        AUTH = 'auth',
        COMPANY = '_C',
        MESSAGES = '_M'
    }

    export enum StatusProcess {
        PRE_PROCESS_PENDING = 'PRE_PROCESS_PENDING',
        PRE_PROCESS_FAILED = 'PRE_PROCESS_FAILED',
        PRE_PROCESS_DONE = 'PRE_PROCESS_DONE',
        PROCESS_CANCELLED_BY_USER = 'PROCESS_CANCELLED_BY_USER', // <== when???
        PROCESS_CANCELLED_BY_PROCESS = 'PROCESS_CANCELLED_BY_PROCESS',
        PROCESS_PENDING = 'PROCESS_PENDING',
        PROCESS_DONE = 'PROCESS_DONE',
        PROCESS_DONE_WITH_WARNINGS = 'PROCESS_DONE_WITH_WARNINGS',
        PROCESS_FAILED = 'PROCESS_FAILED'
    }

    export enum StatusFile {
        NOT_REVIEWED = 'NOT_REVIEWED',
        REVIEWED = 'REVIEWED',
        SIGNED = 'SIGNED',
    }

    export enum StatusEcommerce {
        PENDING = 'Pending',
        ACCEPTED = 'Accepted',
        SHIPPED = 'Shipped'
    }

    export enum ContentType {
        JSON = 'application/json',
        OCTET_STREAM = 'application/octet-stream'
    }

    export enum ResponseType {
        BLOB = 'blob',
        ARRAY_BUFFER = 'arraybuffer'
    }

    export enum ErrorCode {
        TOKEN_EXPIRED = 'TOKEN_EXPIRED',
        SERVER_UNAVAILABLE = 'SERVER_UNAVAILABLE',
        SERVER_ERROR = 'SERVER_ERROR',
        SERVER_TIMEOUT = 'SERVER_TIMEOUT',
        EMPTY_RESULT = 'EMPTY_RESULT'
    }

    export enum CustomElementTypes {
        TEXT = 'text',
        CARRUSEL = 'carrusel',
        LINKS = 'links',
        LIST = 'list',
        LIST_UNORDERED = 'list-unordered',
        LIST_ORDERED = 'list-ordered',
        QUICK_REPLY = 'quick-reply',
        BUTTON = 'button-intent',
        MULTIMEDIA_IMAGE = 'multimedia-image',
        MULTIMEDIA_AUDIO = 'multimedia-audio',
        MULTIMEDIA_VIDEO = 'multimedia-video',
        MULTIMEDIA_FILE = 'multimedia-file',
        MULTIMEDIA_STICKET = 'multimedia-sticker',
    }

    export enum MessageSender {
        USER = 'user',
        WATSON = 'watson'
    }

    export enum TypeOrden {
        SIMPLE = 'Simple',
        COMPLETE = 'Complete'
    }

}
